import React from 'react';
import { useTranslation } from "react-i18next";

interface OrderTagsProps {
    tags: string[];
}

const OrderTags: React.FC<OrderTagsProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className="orderTags__container">
            <div className="orderTags__container-wrap">
                <div className="orderTags__container-wrap-title">
                    <span>{t('food.relatedProduct')}</span>
                </div>

                <div className="orderTags__container-wrap-tags">
                    {
                        props.tags.map((tag, index) => {
                                return (
                                    <div className="orderTags__container-wrap-tag" key={index}>
                                        <span>{tag}</span>
                                    </div>
                                );
                            }
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default OrderTags;